import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notifyLogout } from "../../contexts/AuthContext";
import "./ChannelSidebar.css";

// Which "new feature" dots this browser has already had shown to it. Kept in
// localStorage rather than on the account: the dot is a nudge, not a setting,
// and a nudge that survives forever stops being one.
const SEEN_BADGES_KEY = "adm_seen_menu_badges";

function readSeenBadges() {
  try {
    const raw = JSON.parse(localStorage.getItem(SEEN_BADGES_KEY) || "[]");
    return new Set(Array.isArray(raw) ? raw : []);
  } catch {
    return new Set();
  }
}

export const menuItems = [
  { key: "overview", icon: "fa-house", label: "Overview" },
  { key: "overviewtsatdemo", icon: "fa-house", label: "Overview" },
  { key: "avgactivetv", icon: "fa-tv", label: "Avg. Active TV" },
  { key: "avgactivetvtsatdemo", icon: "fa-tv", label: "Avg. Active TV" },
  { key: "avgactivevw", icon: "fa-flag", label: "Avg Act. Viewers" },
  { key: "totalviewerstr", icon: "fa-flag", label: "Total Viewers Türkiye" },
  { key: "switchin", icon: "fa-eye", label: "Switch-In" },
  { key: "switchintsatdemo", icon: "fa-eye", label: "Switch-In" },
  { key: "uniquetv", icon: "fa-desktop", label: "Unique TVs" },
  { key: "avgvidconsumption", icon: "fa-play", label: "Avg. Vid. Con." },
  { key: "tuneinout", icon: "fa-chart-line", label: "Tune-in/out" },
  { key: "channelgrid", icon: "fa-th-large", label: "Channel Grid" },
  { key: "channelgridtv8", icon: "fa-th-large", label: "Channel Grid" },
  { key: "channelgridnow", icon: "fa-th-large", label: "Channel Grid" },
  { key: "channelgridcomparison", icon: "fa-map", label: "Channel Grid Comparison" },
  { key: "segmentanalysis", icon: "fa-arrows-alt-h", label: "Segment Analysis" },
  { key: "socialmediacompare", icon: "fa-solid fa-thumbs-up", label: "Social Media Compare" },
  { key: "youtubecompare", icon: "fa-brands fa-youtube", label: "Inteltube.live" },
  // badge: a red dot marking the item as new, until the user opens it once.
  { key: "liveranking", icon: "fa-ranking-star", label: "IntelTube live ranking", badge: true },
  { key: "crosscomparison", icon: "fa-equals", label: "Cross Comparison" },
  { key: "channelshare", icon: "fa-chart-line", label: "Channel Share" },
  { key: "pastperformance", icon: "fa-history", label: "Past Performance" },
  { key: "managementreport", icon: "fa-tasks theme--dark", label: "Management Report" },
  { key: "location", icon: "fa-globe", label: "Location" },
];

export default function ChannelSidebar({
  activeItem,
  onItemClick,
  userSidebarItems = [],
  channelSidebarItems = [],
  sidebarOpen,
  onSidebarToggle,
}) {
  const navigate = useNavigate();
  const [seenBadges, setSeenBadges] = useState(readSeenBadges);

  const markBadgeSeen = (key) => {
    if (seenBadges.has(key)) return;
    const next = new Set(seenBadges).add(key);
    setSeenBadges(next);
    try {
      localStorage.setItem(SEEN_BADGES_KEY, JSON.stringify([...next]));
    } catch {
      /* private mode — the dot simply comes back next time */
    }
  };

  const allowedItems = menuItems.filter(
    (item) =>
      userSidebarItems.includes(item.key) &&
      channelSidebarItems.includes(item.key)
  );

  const handleToggle = () => {
    onSidebarToggle(!sidebarOpen);
    
    // Trigger window resize after animation completes (300ms)
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 350);
  };

  return (
    <>
      {/* BURGER BUTTON */}
      <button
        className="sidebar-burger-btn"
        onClick={handleToggle}
        title={sidebarOpen ? "Close menu" : "Open menu"}
      >
        <i className="fa-solid fa-bars" />
      </button>

      {/* SIDEBAR */}
      <div className={`side-menu ${sidebarOpen ? "open" : "closed"}`}>
        {/* MENU LIST */}
        <div className="menu-list">
          {allowedItems.map((m) => (
            <div
              key={m.key}
              className={`menu-item ${activeItem === m.key ? "active" : ""}`}
              onClick={() => {
                markBadgeSeen(m.key);
                if (activeItem !== m.key) onItemClick(m.key);
              }}
            >
              <span className="icon">
                <i className={`fa-solid ${m.icon}`} />
                {m.badge && !seenBadges.has(m.key) && (
                  <span className="menu-badge" aria-label="New" />
                )}
              </span>
              <span className="label">{m.label}</span>
            </div>
          ))}
        </div>

        {/* FOOTER */}
        <div className="menu-footer">
          <button
            className="footer-btn"
            title="Profile"
            onClick={() => navigate("/profile")}
          >
            <i className="fa-solid fa-user" />
          </button>

          <button
            className="footer-btn"
            title="Logout"
            onClick={() => {
              notifyLogout();
              localStorage.removeItem("adm_panel_user");
              localStorage.removeItem("adm_panel_token");
              window.location.href = "/login";
            }}
          >
            <i className="fa-solid fa-power-off" />
          </button>
        </div>
      </div>
    </>
  );
}
